import type { GatsbyBrowser } from 'gatsby';
import './src/styles/global.css';

// Ensure styles are applied on client entry
export const onClientEntry: GatsbyBrowser['onClientEntry'] = () => {
  // Client-side initialization if needed
};
